import React from "react";
import Icon from "./Icon";

export function EmptyState({ icon = "layers", title, subtitle, message, action, image }) {
  const desc = subtitle || message;
  return (
    <div style={{ textAlign: "center", padding: "48px 20px" }}>
      {image ? (
        <div style={{ marginBottom: 14 }}>{image}</div>
      ) : (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 60,
            height: 60,
            borderRadius: 16,
            background: "linear-gradient(135deg, #EEF2FF 0%, #E0E7FF 100%)",
            border: "1px solid #C7D2FE",
            marginBottom: 14,
            boxShadow: "0 2px 8px rgba(99, 102, 241, 0.08)",
          }}
        >
          <Icon name={icon || "layers"} size={28} color="#4F46E5" />
        </div>
      )}
      <div style={{ fontSize: 15, fontWeight: 600, color: "#1E293B" }}>
        {title || "No items found"}
      </div>
      {desc && (
        <div
          style={{
            fontSize: 13,
            color: "#64748B",
            marginTop: 5,
            maxWidth: 420,
            margin: "5px auto 0",
            lineHeight: 1.45,
          }}
        >
          {desc}
        </div>
      )}
      {action && <div style={{ marginTop: 16 }}>{action}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry }) {
  return (
    <div style={{ textAlign: "center", padding: "48px 20px" }}>
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 48,
          height: 48,
          borderRadius: 12,
          background: "#FEF2F2",
          marginBottom: 12,
        }}
      >
        <Icon name="alert" size={22} color="#DC2626" />
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#DC2626",
          fontWeight: 500,
          marginBottom: 10,
        }}
      >
        {message}
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 6,
            padding: "7px 14px",
            background: "#1D4ED8",
            color: "#fff",
            border: "none",
            borderRadius: 7,
            fontSize: 12,
            cursor: "pointer",
          }}
        >
          <Icon name="refresh" size={13} color="#fff" /> Retry
        </button>
      )}
    </div>
  );
}
